import { APIClientError } from './api-client-error';

export class NetworkError extends APIClientError {
  public constructor(message: string, cause?: Error) {
    super(message);
    this.name = 'NetworkError';
    this.cause = cause;
  }
}
